// extracted by mini-css-extract-plugin
export default {"categoryTitle":"ProductIntro_categoryTitle__R2MhL"};